export const charCounts = (selector, limit = 150, counterText = "bokstaver") => {
    if (typeof selector !== 'string' && typeof limit !== 'number') return;
    //Finner elem som selector skal settes på
    const parent = document.querySelector(selector);
    //finner child/children av elem
    const el = parent.querySelectorAll('.scWebEditInput');
    //Gjør klar block som teller skal ligge i
    const div = `<div class="msgcounter"></div>`;
    //Gjør klar hele teller blokka, onload og keyup
    const init = () => {
        if (el === null) {
            throw new Error(`Something's wrong with your selector`)
        }
        setTimeout(function () {
            createDiv();
            counters();
        }, 0);
        el.forEach(element => element.addEventListener('keyup', counters, false) );
    }
    //Bestemmer hvor teller skal ligge
    const createDiv = () => el[el.length - 1].insertAdjacentHTML('afterend', div)
    //Teller metoden
    const counters = () => {
        let total = limit;
        let typedCharacters = 0;
        el.forEach(function (element) {
            typedCharacters += element.textContent.length;
        })
        let count = parent.querySelector('.msgcounter');
        count.innerHTML = `${typedCharacters} av ${total} ` + counterText;
        count.classList.remove('longs');
        if (typedCharacters > total) {
            //el[el.length - 1].focus();
            count.classList.add('longs');
            count.innerHTML = `For mange bokstaver`;
        }
    }
    init();
};
